//
//
//
//
//
//
//
//
//

export default {
    props: {
        timeout: {
            type: Number,
            default: 3000
        },
        transition: {
            type: String,
            default: 'slide-fade'
        },
        types: {
            type: Object,
            default: function _default() {
                return {
                    base: 'alert',
                    success: 'alert-success',
                    error: 'alert-danger',
                    warning: 'alert-warning',
                    info: 'alert-info'
                };
            }
        },
        displayIcons: {
            type: Boolean,
            default: false
        },
        icons: {
            type: Object,
            default: function _default() {
                return {
                    base: 'fa',
                    error: 'fa-exclamation-circle',
                    success: 'fa-check-circle',
                    info: 'fa-info-circle',
                    warning: 'fa-exclamation-circle'
                };
            }
        }
    },

    data: function data() {
        return {
            notifications: []
        };
    },

    /**
     * On creation Flash a message if a message exists otherwise listen for
     * flash event from global event bus
     */
    created: function created() {
        if (process.client) {
            window.flash = this.flash;
        }
    },


    methods: {
        /**
         * Flash our alert to the screen for the user to see
         * and begin the process to hide it
         *
         * @param message
         * @param type
         */
        flash: function flash(message, type) {
            this.notifications.push({
                message: message,
                type: type,
                typeObject: this.classes(this.types, type),
                iconObject: this.classes(this.icons, type)
            });
            setTimeout(this.hide, this.timeout);
        },


        /**
         * Sets and returns the values needed
         *
         * @param type
         */
        classes: function classes(propObject, type) {
            var classes = {};

            if (propObject.hasOwnProperty('base')) {
                classes[propObject.base] = true;
            }
            if (propObject.hasOwnProperty(type)) {
                classes[propObject[type]] = true;
            }

            return classes;
        },


        /**
         * Hide Our Alert
         *
         * @param item
         */
        hide: function hide() {
            var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.notifications[0];

            var key = this.notifications.indexOf(item);
            this.notifications.splice(key, 1);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Flash.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Flash.vue
// module chunks = 15 16 17 18 20